import { render, staticRenderFns } from "./DraftListEditB5.vue?vue&type=template&id=f6e9a420"
import script from "./DraftListEditB5.vue?vue&type=script&lang=js"
export * from "./DraftListEditB5.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports